import React from "react";
import { Route, Switch } from "react-router-dom";
import AppliedRoute from "./components/AppliedRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnAuthenticatedRoute from "./components/UnAuthenticatedRoute"
import Home from "./containers/Home";
import Login from "./containers/auth/views/Login";
import Register from "./containers/auth/views/Register";
import CreateStory from "./containers/stories/create";
import Story from "./containers/stories/story";
import MyStories from "./containers/user/myStories";
import pageNotFound from "./containers/errors/views/pageNotFound";
import AdviceLibrary from "./containers/pages/advice/AdviceLibrary";
import ResourceLibrary from "./containers/pages/resources/ResourceLibrary";
import GameLibrary from "./containers/pages/games/GameLibrary";
import StoryLibrary from "./containers/pages/stories/StoryLibrary";
import About from "./containers/pages/company/About";
import Account from "./containers/pages/user/Account";

export default ({ childProps }) =>
  <Switch>
    <AppliedRoute path="/" exact component={Home} props={childProps} />
    <AppliedRoute path="/stories/:id" exact component={Story} props={childProps} />
    <AppliedRoute path="/advice" exact component={AdviceLibrary} props={childProps} />
    <AppliedRoute path="/stories" exact component={StoryLibrary} props={childProps} />
    <AppliedRoute path="/resources" exact component={ResourceLibrary} props={childProps} />
    <AppliedRoute path="/games" exact component={GameLibrary} props={childProps} />
    <AppliedRoute path="/about" exact component={About} props={childProps} />

    {/* authenticated routes */}
    <AuthenticatedRoute path="/stories/create" exact component={CreateStory} props={childProps} />
    <AuthenticatedRoute path="/myStories" exact component={MyStories} props={childProps} />
    <AuthenticatedRoute path="/account" exact component={Account} props={childProps} />

    {/* un-authenticated routes */}
    <UnAuthenticatedRoute path="/login" exact component={Login} props={childProps} />
    <UnAuthenticatedRoute path="/register" exact component={Register} props={childProps} />

    {/* Finally catch all other routes */}
    <Route component={pageNotFound} />
  </Switch>;



// WEBPACK FOOTER //
// ./src/Routes.js